
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[areaId]/find-car",
      function () {
        return require("private-next-pages/[areaId]/find-car/index.tsx");
      }
    ]);
  